import {Funcao} from "./enums";
import {Column, Entity, JoinTable, ManyToMany, PrimaryGeneratedColumn, Table} from "typeorm";
import {Entidade} from "./Entidade";

@Entity("pessoa")
export class Pessoa   extends Entidade{
    @Column({nullable: false})
    nome?: string
    @Column()
    email?: string
    // @JoinTable({
    //   name: 'pessoa_funcoes',
    //   joinColumn: {
    //     name: 'pessoa_id',
    //     referencedColumnName: 'id',
    //   },
    //   inverseJoinColumn: {
    //     name: 'funcoes'
    //   },
    // })
    // @ManyToMany(() => Pessoa, {cascade: true})
    @Column({type: "simple-array", array: true})
    funcoes?: Funcao[]
    @Column()
    agencia_sigla?: string

}
